import React, { useContext } from 'react';
import { AppContext } from '../../App';
import { colorMap, whichColorMapObject } from '../../utils/validationUtils';

interface IgnoredIconProps {
  field: string;
  style?: React.CSSProperties;
}

const IgnoredIcon: React.FC<IgnoredIconProps> = ({ field, style }) => {
  const { accessibility } = useContext(AppContext);
  const colorMode = whichColorMapObject(accessibility);

  return (
    <span
      title="Error Ignored"
      data-cy={`ignore-error-icon-${field}`}
      style={{
        position: 'absolute',
        top: '2px',
        right: '4px',
        fontSize: '0.75rem',
        lineHeight: 1,
        color: colorMap[colorMode].missing.color,
        pointerEvents: 'none',
        ...style,
      }}
    >
      ⚠
    </span>
  );
};

export default IgnoredIcon;
